import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import IssuesOverviewTemplate from 'src/components/IssuesOverviewTemplate';
import { requestAPI } from 'src/redux/api/actions';
import { clearApiKeys } from 'src/redux/api/actions';
import { ACR_ISSUES_OVERVIEW_URL } from 'src/redux/constants';

const IssuesOverview: FC = () => {
  const dispatch = useDispatch();

  const { year, cpb: projectId } = useParams();

  useEffect(() => {
    if (!year || !projectId) return;

    dispatch(
      requestAPI(ACR_ISSUES_OVERVIEW_URL, {
        url_format: {
          _period_: year,
          _cpb_key_: projectId,
        },
      }),
    );

    return () => {
      dispatch(clearApiKeys([ACR_ISSUES_OVERVIEW_URL]));
    };
  }, [year, projectId]);

  return <IssuesOverviewTemplate />;
};
export default IssuesOverview;
